<div class="menu">
    <div class="menu-title" (click)="selectOption(null)">
        <div class="title01">{{i18n._.SELECTION}}</div>
        <div class="title02">KUBE</div>
    </div>
    <div *ngFor="let item of options"
        [ngClass]="['menu-option', item.typeClass]"
        [class.not-selected]="selectedOption != null && selectedOption != item.id"
        [class.selected]="selectedOption == item.id"
        (click)="selectOption(item.id)"
        (mouseenter)="onItemHover(item.id)"
        (mouseleave)="onItemHover(null)">
        {{item.name}} 
    </div>
</div>